<div class="main-container">
  <app-header></app-header>
  <div class="iti-page">
    <div class="iti-page-left">
      <div class="notification-filter-option">
        <div class="filter-option">
          <div class="filter-option-header">Search by Date</div>
          <div class="filter-option-date form-group">
            <mat-form-field>
              <input
                matInput
                [matDatepicker]="picker1"
                placeholder="From Date"
                [(ngModel)]="startDate"
                name="fromDate"
                [max]="today"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker1"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker1 color="primary"></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
              <input
                matInput
                [matDatepicker]="picker2"
                placeholder="To Date"
                [(ngModel)]="endDate"
                name="endDate"
                [max]="today"
                [min]="startDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker2"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker2 color="primary"></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="filter-action-go">
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="readNotificationHistory()"
            >
              GO
            </button>
          </div>
        </div>

        <div class="filter-option">
          <div class="filter-option-header tag-search">Search by Tag</div>
          <div class="filter-option-tag">
            <div class="filter-option-tag-item">
              <mat-checkbox
                *ngFor="let item of tagList"
                [checked]="tagSelection.isSelected(item)"
                (change)="
                  $event ? tagSelection.toggle(item) : null;
                  readNotificationHistory()
                "
              >
                {{ item.tagName }}
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="iti-page-right">
      <div class="iti-page-right-content">
        <div class="notification-history-result">
          <div class="conatiner-page-header align-h">
            <button mat-icon-button (click)="pageBack()">
              <mat-icon class="mat-icon-48">keyboard_arrow_left</mat-icon>
            </button>
            <span class="margin-left-15">Sent Notification History</span>
          </div>

          <div class="notification-history-list">
            <div
              class="notification-list-item"
              *ngFor="let history of historyNotifications"
            >
              <div class="notification-history-timestamp-item">
                <ul class="pipe-separated-list">
                  <li>{{ history.date }}</li>
                  <li>{{ history.time }}</li>
                </ul>
              </div>
              <div class="notification-list-content">
                <div class="notification-list-item-image">
                  <img
                    *ngIf="history?.imageUrl"
                    src="{{ history?.imageUrl }}"
                    [attr.alt]="history?.title"
                  />
                </div>
                <div class="notification-list-item-text">
                  <h4>{{ history?.title }}</h4>
                  <p>{{ history?.description }}</p>
                  <p>{{ history?.link }}</p>
                  <div class="notifcation-tag-content">
                    <label>Selected Tags</label>
                    <div class="notifcation-tags">
                      <h4 *ngFor="let tag of history?.tags">
                        {{ tag?.tagName }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- -NO DATA -->
            <div *ngIf="historyNotifications?.length === 0">
              <p class="no-data">No data found</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
